































import { Component, Vue, Prop } from 'vue-property-decorator';
import Drayage from '@/components/shipment/activity/Drayage.vue';
import MarineTrafficMap from '@/components/shipment/MarineTrafficMap.vue';
import Milestones from '@/components/shipment/activity/Milestones.vue';
import TasksList from '@/components/task/TasksList.vue';

// gql
import fetchShipmentMilestoneQuery from '@/graphql/queries/shipment/FetchShipmentMilestone.gql';
import fetchTasksQuery from '@/graphql/queries/FetchTasks.gql';

// types
import {
  MilestoneFields,
  ShipmentFields,
  TaskFields,
  TaskOrderEnum,
  TaskFilterEnum
} from '@/types/graphql/schemaTypes';

@Component({
  components: {
    Drayage,
    MarineTrafficMap,
    Milestones,
    TasksList
  },
  apollo: {
    shipmentMilestone: {
      query: fetchShipmentMilestoneQuery,
      variables() {
        return {
          shipmentArgs: {
            shipmentId: this.$route.params.id
          }
        };
      },
      update(data) {
        this.trackableMilestone = data?.shipments[0]?.trackableMilestone;

        return data?.shipments[0];
      },
      fetchPolicy: 'cache-and-network',
      error() {
        this.$store.dispatch('Alert/addAlert', {
          type: 'error',
          message: this.$t('error.fetch'),
          time: 2000
        });
      }
    },
    tasks: {
      query: fetchTasksQuery,
      prefetch: true,
      variables() {
        return {
          searchArgs: { shipmentId: this.$route.params.id },
          ordering: TaskOrderEnum.ORDER_ASC,
          filter: TaskFilterEnum.NOT_DONE
        };
      },
      fetchPolicy: 'cache-and-network',
      error() {
        this.$store.dispatch('Alert/addAlert', {
          type: 'error',
          message: this.$t('error.fetch'),
          time: 2000
        });
      }
    }
  }
})
export default class Activities extends Vue {
  @Prop({ required: true }) shipment!: ShipmentFields;

  created() {
    this.$emit('refresh');
  }

  // Data
  get shipmentStatus() {
    return {
      id: this.shipment.id,
      status: this.shipment.status || '',
      statusComment: this.shipment.statusComment || '',
      isProblem: this.shipment.isProblem || false
    };
  }

  shipmentMilestone?: ShipmentFields;
  tasks: TaskFields[] = [];
  trackableMilestone: MilestoneFields | null = null;

  get drayageBookings() {
    if (!this.shipmentMilestone) return null;
    const drayageBookings = [];
    switch (this.shipmentMilestone.customerRole) {
      // Export shipments: pickup milestone is the target
      case 'seller':
        this.shipmentMilestone.milestones.forEach((milestone) => {
          if (milestone.milestoneType === 'pickup') {
            drayageBookings.push(milestone);
          }
        });
        break;
      // Import shipments: delivery milestone is the target
      case 'buyer':
        this.shipmentMilestone.milestones.forEach((milestone) => {
          if (milestone.milestoneType === 'delivery') {
            drayageBookings.push(milestone);
          }
        });
        break;
    }
    return drayageBookings;
  }

  get isDrayageDisplayed() {
    if (!this.drayageBookings) return false;
    return this.drayageBookings.length > 0;
  }

  refresh() {
    this.$emit('refresh');
  }
}
